var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3923 3.6906C20.8675 5.11966 22.3923 7.76068 22.3923 10.6188V13.3812C22.3923 16.2393 20.8675 18.8803 18.3923 20.3094L16 21.6906C13.5248 23.1197 10.4752 23.1197 8 21.6906L5.6077 20.3094C3.13249 18.8803 1.6077 16.2393 1.6077 13.3812V10.6188C1.6077 7.76068 3.13249 5.11966 5.6077 3.6906L8 2.3094C10.4752 0.880339 13.5248 0.880339 16 2.3094L18.3923 3.6906Z",
    fill: "url(#paint0_angular_5397_217125)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.793 4.6139C19.2682 6.04296 20.793 8.68398 20.793 11.5421V12.4583C20.793 15.3165 19.2682 17.9575 16.793 19.3865L15.9995 19.8447C13.5243 21.2737 10.4748 21.2737 7.99954 19.8447L7.20606 19.3866C4.73085 17.9575 3.20605 15.3165 3.20605 12.4583V11.5421C3.20605 8.68398 4.73085 6.04296 7.20605 4.6139L7.99954 4.15578C10.4747 2.72672 13.5243 2.72672 15.9995 4.15578L16.793 4.6139Z",
    fill: "#F3DA9A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.293 12.4583V11.5421C20.293 8.86261 18.8635 6.38666 16.543 5.04691L15.7495 4.58879C13.429 3.24905 10.57 3.24905 8.24954 4.58879L7.45605 5.04691C5.13555 6.38666 3.70605 8.86262 3.70605 11.5421V12.4583C3.70605 15.1378 5.13555 17.6138 7.45606 18.9535L8.24954 19.4117C10.5701 20.7514 13.429 20.7514 15.7495 19.4117L16.543 18.9535C18.8635 17.6138 20.293 15.1378 20.293 12.4583ZM20.793 11.5421C20.793 8.68398 19.2682 6.04296 16.793 4.6139L15.9995 4.15578C13.5243 2.72672 10.4747 2.72672 7.99954 4.15578L7.20605 4.6139C4.73085 6.04296 3.20605 8.68398 3.20605 11.5421V12.4583C3.20605 15.3165 4.73085 17.9575 7.20606 19.3865L7.99954 19.8447C10.4748 21.2737 13.5243 21.2737 15.9995 19.8447L16.793 19.3865C19.2682 17.9575 20.793 15.3165 20.793 12.4583V11.5421Z",
    fill: "url(#paint1_linear_5397_217125)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8843 5.54649C18.2458 6.9099 19.7005 9.42959 19.7005 12.1564C19.7005 14.8832 18.2458 17.4029 15.8843 18.7663C13.5228 20.1298 10.6133 20.1298 8.25179 18.7663C5.89029 17.4029 4.43555 14.8832 4.43555 12.1564C4.43555 9.42959 5.89029 6.9099 8.25179 5.54649C10.6133 4.18307 13.5228 4.18307 15.8843 5.54649Z",
    fill: "url(#paint2_radial_5397_217125)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3843 6.41251C13.3322 5.22773 10.8039 5.22773 8.75179 6.41251C6.69969 7.59729 5.43555 9.78686 5.43555 12.1564C5.43555 14.526 6.69969 16.7155 8.75179 17.9003C10.8039 19.0851 13.3322 19.0851 15.3843 17.9003C17.4364 16.7155 18.7005 14.526 18.7005 12.1564C18.7005 9.78686 17.4364 7.59729 15.3843 6.41251ZM19.7005 12.1564C19.7005 9.42959 18.2458 6.9099 15.8843 5.54649C13.5228 4.18307 10.6133 4.18307 8.25179 5.54649C5.89029 6.9099 4.43555 9.42959 4.43555 12.1564C4.43555 14.8832 5.89029 17.4029 8.25179 18.7663C10.6133 20.1298 13.5228 20.1298 15.8843 18.7663C18.2458 17.4029 19.7005 14.8832 19.7005 12.1564Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4454 14.6702C13.8636 11.5317 14.7384 10.4495 15.1626 9.99405C15.0071 9.35639 14.4555 8.05071 13.6979 8.77946C12.9403 9.50822 12.2332 11.7613 11.9302 12.7269C12.2706 14.4941 12.7383 14.6702 13.4454 14.6702Z",
    fill: "url(#paint3_linear_5397_217125)",
    fillOpacity: 0.62
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7791 10.8992C16.7085 10.7443 16.2404 10.1809 15.1629 9.1034C14.0057 7.94614 13.6585 8.83802 13.1875 9.46256C14.6242 10.1809 15.8518 11.6536 16.1344 12.5154L16.7791 10.8992Z",
    fill: "#FFE49A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.90234 10.1735C11.1942 12.3292 11.6831 16.5241 11.8461 16.4659C13.0848 16.0231 13.3184 14.7413 13.3673 14.2519C13.176 13.618 12.2807 11.7466 10.4879 10.1735C8.69514 8.60045 6.90234 9.59091 6.90234 9.59091V10.1735Z",
    fill: "#FFE49A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7358 19.8701L11.9907 18.6152L13.2456 19.8701L11.9907 21.125L10.7358 19.8701Z",
    fill: "url(#paint4_linear_5397_217125)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.453 19.7311L11.9912 21.5587L11.9912 21.0474L10.8228 19.8116L10.453 19.7311Z",
    fill: "url(#paint5_linear_5397_217125)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9907 21.0473L11.9907 21.5586L13.5442 19.731L13.1743 19.8115L11.9907 21.0473Z",
    fill: "url(#paint6_linear_5397_217125)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_5397_217125",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12 12) scale(12)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0052,
    stopColor: "#B05908"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2442,
    stopColor: "#BE9659"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.276042,
    stopColor: "#FFF279"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.515625,
    stopColor: "#FFE39B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.708333,
    stopColor: "#FFE587"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.765625,
    stopColor: "#925846"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5397_217125",
    x1: 1.8457,
    y1: 1.84638,
    x2: 1.8457,
    y2: 22.1541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7B31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFDB1F",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_5397_217125",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(12.068 12.1564) rotate(90) scale(6.83061)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B97D38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F2D00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5397_217125",
    x1: 11.9302,
    y1: 8.56445,
    x2: 11.9302,
    y2: 14.6702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5397_217125",
    x1: 10.7358,
    y1: 21.125,
    x2: 13.2456,
    y2: 21.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8797F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B68B9D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5397_217125",
    x1: 10.3083,
    y1: 19.8758,
    x2: 11.9912,
    y2: 21.5587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A07278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5603,
    stopColor: "#D6B9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#A07278"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_5397_217125",
    x1: 11.9907,
    y1: 21.5586,
    x2: 13.6813,
    y2: 19.8681,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85555B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5603,
    stopColor: "#D6B9BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9998,
    stopColor: "#A07278"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVip);
export default __webpack_public_path__ + "static/media/vip.c26943df30b064b56143bb7f11d1b3f9.svg";
export { ForwardRef as ReactComponent };